module.exports = __webpack_public_path__ + "img/symbol_6.3db1c94c.png";